<template>
  <div id="app">
    <router-view/>
    <div class="pfixed p100 perr" id="piusdf" v-if="isIE">
      <div class="nt pabsolute p100">
        <div class="adiv">
          <a href="javascript:;" class="ex chrome dblock mb20"></a>
          <a href="javascript:;" class="ex firefox dblock"></a>
        </div>
        <a href="javascript:;" @click="closeIE" class="close pabsolute hbig"></a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data(){
      return {
        isIE:false,
      }
    },
    created() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      var browserType = "", browserVersion = "";
      if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        this.isIE = true;
      }else{

      }
    },
    methods:{
      closeIE:function () {
        this.isIE = false;
      }
    }
  }
</script>
<style>
.perr{
  z-index: 1025;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .7);
}
.perr .nt{margin: auto;width: 607px;height: 454px;background: url(./assets/images/err_01.png) no-repeat;}
.perr .adiv{margin: 280px 0 0 45px;}
.perr .ex:hover{box-shadow: 2px 2px 5px #333;}
.perr .ex{width: 195px;height: 53px;background: url(./assets/images/err_02.png) no-repeat;box-shadow: 2px 2px 5px #666;}
.perr .firefox{background-position: 0 -70px;}
.perr .close{left: 50%;bottom: -80px;margin-left: -70px;width: 70px;height: 70px;background: url(./assets/images/err_03.png) no-repeat;}
</style>



// WEBPACK FOOTER //
// src/App.vue